import { atom } from "recoil";

// current tenant

const tenantStatusState = atom({
    key: "tenantStatus",
    default: undefined
});

export default tenantStatusState;